import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { DialogComponent } from '../../dialog/dialog.component';
import { MessageService } from 'primeng/api';
import { Store, select } from '@ngrx/store';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject } from 'rxjs';
import * as fromStore from '../../store';
import * as fromFeature from '../../my-features';
import { OAuthPlatformType, updateInfoType , CheckAuthOtpErrMsg, OAuthLoginMessage, OAuthAddErrorMessage,
         OAuthDeleteErrorMessage, AuthOtpType, AuthOtpDeviceType } from 'src/app/shareModel';
import { UpdateInfoModel } from '../../my-features/updateInfo/update-info.model';
import { AccountOauthParam } from 'src/app/my-features/account/oauth.model';
import { map, filter, switchMap, tap, takeUntil } from 'rxjs/operators';
import { relativeTimeThreshold } from 'moment';
import { environment } from 'src/environments/environment';
import { AccountService } from '../../services/account.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-twofactor-social',
  templateUrl: './twofactor-social.component.html',
  styleUrls: ['./twofactor-social.component.css']
})
export class TwofactorSocialComponent implements OnInit, OnDestroy {
  @ViewChild(DialogComponent, { static: false }) childDialog: DialogComponent;
  private componentDestroyed = new Subject();
  isProd = environment.production;
  twoFactorAuthentication = false;
  twoFactorStatus = 'Enable';
  appleChecked = false;
  googleChecked = false;
  facebookChecked = false;
  selectedCities: string[] = [];
  Oauths: any[] = [];
  UpdateInfoParam = {} as UpdateInfoModel;
  otp: string;
  message: string;
  id: Number;
  OAuthAppleEmail: string;
  OAuthGoogleEmail: string;
  OAuthFacebookEmail: string;
  selectedOauth: any;
  currentUser: string;
  otpid: number;
  acode: number;
  accountEmail: string;
  confirmTwoFactorType: string;
  confrimOTPnumberType: string;
  confrimOTPParam =  {
    otp : '',
    authId: 0,
    authType: AuthOtpType.DisableOTP,
    authOtp: this.accountService.GetAuthOtp,
  };
  constructor(private messageService: MessageService,
    private store: Store<fromStore.State>,
    private ngxService: NgxUiLoaderService,
    private accountService: AccountService,
    private translateService: TranslateService) {

    // Get Preferences
    this.store.dispatch(new fromFeature.GetPreferences());
    // Get Account Oauth Info
    this.store.dispatch(new fromFeature.GetOauths());

    // Get User Info
    this.store.pipe(select(fromStore.getCurrentUser)).subscribe(res => {
      this.currentUser = res.currentUser;
      this.acode = res.acode;
    });

    this.store.select(fromStore.getOauth).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (!res.Loading && res.Loaded) {
        this.Oauths = Object.values(res.entities);
        // filter篩選掉SSO的AccountOauth
        this.Oauths = this.Oauths.filter((i) => i.Platform !== OAuthPlatformType.SSO);
        if (this.Oauths.length > 0) {
          this.Oauths.map(data => {
            if (data.Platform === OAuthPlatformType.Apple) {
              this.appleChecked = true;
              this.OAuthAppleEmail = data.Email;
            } else if (data.Platform === OAuthPlatformType.Google) {
              this.googleChecked = true;
              this.OAuthGoogleEmail = data.Email;
            }
            // 2026/07/21 kyrie.hung 移除 Facebook 社群帳號綁定功能
            // else if (data.Platform === OAuthPlatformType.Facebook) {
            //   this.facebookChecked = true;
            //   this.OAuthFacebookEmail = data.Email;
            // }
          });
        } else {
          this.appleChecked = false;
          this.googleChecked = false;
          // this.facebookChecked = false;
          this.OAuthAppleEmail = '';
          this.OAuthGoogleEmail = '';
          // this.OAuthFacebookEmail = '';
        }
      }
    });

    this.store.select(fromStore.getUpdateInfoState).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res.type === updateInfoType.AddOAuth) {
        if (!res.isLoading && res.isLoaded) {
          if (res.isSaved) {
            if (res.msg) {
              if (res.msg.AccountEmail !== res.msg.PlatformEmail) {
                const param = {
                  socialType: res.msg.Platform,
                  AccountEmail: this.accountEmail,
                  PlatformEmail: res.msg.PlatformEmail
                };
                this.childDialog.alertSocialCombineEmailDialog(param);
              } else {
                // tslint:disable-next-line:max-line-length
                this.messageService.add({ severity: 'success', summary: this.translateService.instant('You have combined the social account successfully!') });
              }
            } else {
              // tslint:disable-next-line:max-line-length
              this.messageService.add({ severity: 'success', summary: this.translateService.instant('You have combined the social account successfully!') });
            }
          } else if (!res.isSaved) {
            // tslint:disable-next-line:max-line-length
            this.messageService.add({ severity: 'error', summary: this.translateService.instant('An error occurs when combined your social account. Please try again later.')  });
          }
          if (res.msg === OAuthAddErrorMessage.AlreadyBinded) {
            this.childDialog.alertSocialCombineAccountAlert();
          }
          // remove redirect param
          window.history.pushState({}, document.title, '/account-info' );
          this.ngxService.stop();
        }
        this.resetUpdateInfoState();
      }
      if (res.type === updateInfoType.DeleteOAuth) {
        if (!res.isLoading && res.isLoaded) {
          if (res.isSaved) {
            // tslint:disable-next-line:max-line-length
            this.messageService.add({ severity: 'success', summary: this.translateService.instant('You have cancelled the combination successfully!') });
          } else if (!res.isSaved) {
            if (res.msg === OAuthDeleteErrorMessage.NoCustomPassword) {
              this.childDialog.alertSocialCombineNoPasswordAlert(
                this.getSocialTypeName(this.selectedOauth ? this.selectedOauth.Platform : null));
            } else {
              // tslint:disable-next-line:max-line-length
              this.messageService.add({ severity: 'error', summary: this.translateService.instant('An error occurs when combined your social account. Please try again later.')  });
            }
          }
          this.ngxService.stop();
        }
        this.resetUpdateInfoState();
      }
    });

    this.store.select(fromStore.getPreferences).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if ( res.Loaded && !res.Loading) {
        if (res.entities != null && res.entities !== undefined) {
          this.twoFactorAuthentication = Number(res.entities.EnableOTP) === 1 ? true : false;
        }
      }
    });

    this.store.select(fromStore.getSingleAccountInfo(this.acode)).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res) {
        this.accountEmail = res.Email;
      }
    });

    this.store
    .select(fromStore.getAuthotp)
    .pipe(takeUntil(this.componentDestroyed))
    .subscribe((res) => {
      if (this.confirmTwoFactorType === 'enableTwoFactorConfirm' || this.confirmTwoFactorType === 'disableTwoFactorConfirm') {
        if (res.Loaded && !res.Loading) {
          if (res.entities != null) {
            if (res.entities.Flag) {
              this.childDialog.twoFactorAuthDialog();
              this.otpid = res.entities.Id;
              if (this.confirmTwoFactorType === 'enableTwoFactorConfirm') {
                this.twoFactorStatus = 'Enable';
              } else {
                this.twoFactorStatus = 'Disable';
              }
            } else {
              this.childDialog.alertOTPLock();
              this.accountService.apiAuthOtpEventType();
            }
            this.confirmTwoFactorType = '';
          }
        } else if (!res.Loaded && res.Loading) {
          if (res.entities != null) {
            this.message = res.entities.Message;
          }
        }
      }
    });

    this.store
    .select(fromStore.getCheckAuthOtp)
    .pipe(takeUntil(this.componentDestroyed))
    .subscribe((res) => {
      if (res.Loaded && !res.Loading && this.otpid !== undefined && this.confrimOTPParam !== undefined ) {
        if (res.entities == null) {
          this.ngxService.stop();
          this.confrimOTPnumberType = '';
          return;
        }
        if (res.entities.Flag ) {
          if (res.entities.authType !== undefined && (res.entities.authType === AuthOtpType.EnableOTP || res.entities.authType === AuthOtpType.DisableOTP)) {
            // tslint:disable-next-line:max-line-length
            this.messageService.clear();
            if (this.confrimOTPParam.authType === AuthOtpType.DisableOTP) {
              this.messageService.add({
                severity: 'success',
                summary:
                this.translateService.instant('Update Success'),
              });
              this.twoFactorAuthentication = false;
            } else {
              this.messageService.add({
                severity: 'success',
                summary:
                this.translateService.instant('An OTP will be required when you log in to PowerPanel Cloud next time.'),
              });
            }
            // 切換Enable/Disable Button
            this.twoFactorAuthentication = this.confrimOTPParam.authType === AuthOtpType.DisableOTP ? false : true;
            const enablePaaram = {
              otp: '',
              authId: Number(this.otpid),
              authType: this.twoFactorAuthentication === true ? AuthOtpType.EnableOTP : AuthOtpType.DisableOTP,
            };
            this.store.dispatch(new fromFeature.EnableAuthOtp(enablePaaram));
            if (this.childDialog !== undefined) {
              this.childDialog.closeDialog();
            }
          }
        } else {
          this.childDialog.errorMsg = CheckAuthOtpErrMsg[res.entities.Message];
          if (res.entities.Message === '1' || res.entities.Message === '2') {
            this.childDialog.OTPOvertime = true;
            if (res.entities.Message === '1') {
              this.childDialog.errorMsgByLock = true;
            }
          }
          this.childDialog.dialogSaveDirty = true;
        }
        this.ngxService.stop();
        this.confrimOTPnumberType = '';
      }
    });

    this.accountService.apiTwoFactorStatusEmitter.pipe(takeUntil(this.componentDestroyed)).subscribe(() => {
      this.apiCheckTwoFactorStatus();
    });

    this.accountService.upsControlTwoFactorStatusEmitter.pipe(takeUntil(this.componentDestroyed)).subscribe(() => {
      this.upsControlCheckTwoFactorStatus();
    });

    this.store.select(fromStore.getEnableAuthotp).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if (res.Loaded && !res.Loading) {

        // Get Preferences
        this.store.dispatch(new fromFeature.GetPreferences());
      }
    });
  }

  ngOnInit() {
  }

  upsControlCheckTwoFactorStatus() {
    const isChecked = this.twoFactorAuthentication;
    if (isChecked !== true) {
      this.childDialog.alertUpsControlTwoFactorEnable();
    } else {
      this.accountService.upsControlAuthOtpEvent();
    }
  }

  apiCheckTwoFactorStatus() {
    const isChecked = this.twoFactorAuthentication;
    if (isChecked !== true) {
      this.childDialog.alertAPITwoFactorEnable();
    } else {
      this.accountService.apiAuthOtpEvent();
    }
  }

  checkTwoFactorStatus() {
    const isChecked = this.twoFactorAuthentication;
    if (isChecked === true) {
      this.childDialog.alertTwoFactorAuthDisable();
    } else {
      this.childDialog.alertTwoFactorAuthEnable();
    }
  }

  confirmTwoFactorEnable(result: string) {
    if (result === 'enableTwoFactorConfirm') {
      this.confirmTwoFactorType = result;
      this.childDialog.errorMsg = '';
      const param = {
        otp: '',
        DeviceType: AuthOtpDeviceType.Web,
        AuthType: AuthOtpType.EnableOTP,
      };
      this.confrimOTPParam = { ...this.confrimOTPParam, authType: AuthOtpType.EnableOTP };
      this.id = 0;
      this.store.dispatch(new fromFeature.AddAuthOtp(param));
    }
  }

  confirmTwoFactorDisable(result: string) {
    if (result === 'disableTwoFactorConfirm') {
      this.confirmTwoFactorType = result;
      this.childDialog.errorMsg = '';
      const param = {
        otp: '',
        DeviceType: AuthOtpDeviceType.Web,
        AuthType: AuthOtpType.DisableOTP,
      };
      this.confrimOTPParam = { ...this.confrimOTPParam, authType: AuthOtpType.DisableOTP };
      this.id = 0;
      this.store.dispatch(new fromFeature.AddAuthOtp(param));
      }
  }

  confrimOTPnumber(result: string) {
    if (result === 'confrimOTPnumber') {
      this.confrimOTPnumberType = result;
      this.ngxService.start();
      const param = {
        otp : '',
        authId: Number(this.otpid),
        authType: this.twoFactorStatus === 'Enable' ? AuthOtpType.EnableOTP : AuthOtpType.DisableOTP,
        authOtp: this.accountService.GetAuthOtp,
      };
      this.store.dispatch(new fromFeature.CheckAuthOtp(param));
    }
  }

  checkSocialCombineStatus(socialType) {
    const appleIsChecked = this.appleChecked;
    const googleIsChecked = this.googleChecked;
    const faceBookIsChecked = this.facebookChecked;
    const socialArray = [appleIsChecked, googleIsChecked, faceBookIsChecked];

    if (socialType === 'apple') {
      if (appleIsChecked === true) {
        this.childDialog.alertSocialCombineDisable(socialType);
      } else {
        if (socialArray.includes(true)) {
          this.childDialog.alertSocialCombineOnlyOneAlert();
        } else {
          this.childDialog.alertSocialCombineEnable(socialType);
        }
      }
    }

    if (socialType === 'google') {
      if (googleIsChecked === true) {
        this.childDialog.alertSocialCombineDisable(socialType);
      } else {
        if (socialArray.includes(true)) {
          this.childDialog.alertSocialCombineOnlyOneAlert();
        } else {
          this.childDialog.alertSocialCombineEnable(socialType);
        }
      }
    }

    // 2026/07/21 kyrie.hung 移除 Facebook 社群帳號綁定功能
    // if (socialType === 'facebook') {
    //   if (faceBookIsChecked === true) {
    //     this.childDialog.alertSocialCombineDisable(socialType);
    //   } else {
    //     if (socialArray.includes(true)) {
    //       this.childDialog.alertSocialCombineOnlyOneAlert();
    //     } else {
    //       this.childDialog.alertSocialCombineEnable(socialType);
    //     }
    //   }
    // }
  }

  confrimCombineLogin(result: string) {
    if (result === 'apple_Combine' || result === 'google_Combine' || result === 'facebook_Combine') {
      let url = '';
      switch (result) {
        case 'apple_Combine':
          url = environment.PowerPanelCloudAppleOAuthUrl.replace('{0}', environment.RedirectAuthApiUrl);
          url = url.replace('{1}', '&state=account-info');
          window.location.href = url;
          break;
        case 'google_Combine':
          url = environment.PowerPanelCloudGoogleOAuthUrl.replace('{0}', environment.HomePageUrl + 'account-info');
          url = url.replace('{1}', '');
          window.location.href = url;
          break;
        // 2026/07/21 kyrie.hung 移除 Facebook 社群帳號綁定功能
        // case 'facebook_Combine':
        //   url = environment.PowerPanelCloudFacebookOAuthUrl.replace('{0}', environment.HomePageUrl + 'account-info');
        //   url = url.replace('{1}', '');
        //   window.location.href = url;
        //   break;
      }
    }
  }

  confirmSocialPasswordSetup(result: string) {
    if (result === 'apple_PasswordSetup' || result === 'google_PasswordSetup' || result === 'facebook_PasswordSetup') {
      window.location.href = environment.cyberpowerUrl + '/account/forgot';
    }
  }

  getSocialTypeName(platform: number | null): string {
    switch (platform) {
      case OAuthPlatformType.Apple:
        return 'apple';
      case OAuthPlatformType.Google:
        return 'google';
      // 2026/07/21 kyrie.hung 移除 Facebook 社群帳號綁定功能
      // case OAuthPlatformType.Facebook:
      //   return 'facebook';
      default:
        return 'social';
    }
  }

  cancelSocialCombine(result: string) {
    if (result === 'apple_Cancel' || result === 'google_Cancel' || result === 'facebook_Cancel') {
      let Platform = -1;
      switch (result) {
        case 'apple_Cancel':
          Platform = OAuthPlatformType.Apple;
          break;
        case 'google_Cancel':
          Platform = OAuthPlatformType.Google;
          break;
        // 2026/07/21 kyrie.hung 移除 Facebook 社群帳號綁定功能
        // case 'facebook_Cancel':
        //   Platform = OAuthPlatformType.Facebook;
        //   break;
      }
      this.selectedOauth = this.Oauths.find(res => res.Platform === Platform);
      const param: AccountOauthParam = {
        Code: '',
        Id: this.selectedOauth.Id,
        Platform: this.selectedOauth.Platform,
        Email: this.accountEmail
      };
      this.store.dispatch(new fromFeature.DeleteAccountOauth(param));
    }
  }

  // saveSocialNotificationEmail(result: string) {
  //   if (result === 'apple_SaveNotificationEmail' || result === 'google_SaveNotificationEmail' ||
  //       result === 'facebook_SaveNotificationEmail') {
  //         // console.log('confirmUpdateAccountEmail');
  //         const param: AccountOauthParam = {
  //           Code: ''
  //           // Email: this.accountEmail
  //         };
  //         switch (result) {
  //           case 'apple_SaveNotificationEmail':
  //             break;
  //           case 'google_SaveNotificationEmail':
  //             break;
  //           case 'facebook_SaveNotificationEmail':
  //             break;
  //         }
  //         // this.store.dispatch(new fromFeature.UpdateAccountEmail(param));
  //   }
  // }

  ngOnDestroy(): void {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

  private resetUpdateInfoState(type: string = updateInfoType.FreeState): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(new fromFeature.UpdateInfoSuccessAction({ ...this.UpdateInfoParam }));
  }
}
